import { memo } from 'react';

import { type ClipType } from '@air/api/types';

import { NoPreviewImage } from '~/components/UI/NoPreviewImage';
import { WorkspaceAgentAssetTypeIcon } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/WorkspaceAgentAssetTypeIcon';

export type WorkspaceAgentAssetPreviewMediaFallbackProps = {
  ext: string | null | undefined;
  type: ClipType;
};

/** The extension tile wins over the type glyph: it names the format, where the glyph only names the family. */
export const WorkspaceAgentAssetPreviewMediaFallback = memo(
  ({ ext, type }: WorkspaceAgentAssetPreviewMediaFallbackProps) =>
    ext ? (
      <span className="absolute inset-0 size-full">
        <NoPreviewImage color="color" ext={ext} hideText size="medium" />
      </span>
    ) : (
      <WorkspaceAgentAssetTypeIcon className="ads:text-icon-subtle text-gray-9" size={32} type={type} />
    ),
);

WorkspaceAgentAssetPreviewMediaFallback.displayName = 'WorkspaceAgentAssetPreviewMediaFallback';
